import Templates from './Templates';

export default Templates;



// WEBPACK FOOTER //
// ./src/views/templates/index.js